'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Spotlight = function (_React$Component) {
  _inherits(Spotlight, _React$Component);

  function Spotlight(props) {
    _classCallCheck(this, Spotlight);

    var _this = _possibleConstructorReturn(this, (Spotlight.__proto__ || Object.getPrototypeOf(Spotlight)).call(this, props));

    var isServerSide = typeof window === 'undefined';
    // If the user has server rendering, we assume they have a 4k screen (better aim high than low just in case).
    _this.state = {
      windowWidth: isServerSide ? 3840 : window.innerWidth,
      windowHeight: isServerSide ? 2160 : window.innerHeight
    };

    _this.resizeThrottler = _this.resizeThrottler.bind(_this);
    return _this;
  }

  _createClass(Spotlight, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.responsive) window.addEventListener('resize', this.resizeThrottler);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizeThrottler);
    }

    // https://developer.mozilla.org/en-US/docs/Web/Events/resize#setTimeout

  }, {
    key: 'resizeThrottler',
    value: function resizeThrottler() {
      var _this2 = this;

      // ignore resize events as long as an actualResizeHandler execution is in the queue
      if (!this.resizeTimeout) {
        this.resizeTimeout = setTimeout(function () {
          _this2.resizeTimeout = null;
          _this2.recalc();
        }, 66); // The actualResizeHandler will execute at a rate of 15fps
      }
    }
  }, {
    key: 'recalc',
    value: function recalc() {
      this.setState({
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight
      });
    }
  }, {
    key: 'getBorderSize',
    value: function getBorderSize() {
      // We find the diagonal of the screen and add the circle's radius to ensure
      // that the border covers the screen when the circle is just off screen.
      var diagonal = Math.ceil(Math.sqrt(Math.pow(this.state.windowWidth, 2) + Math.pow(this.state.windowHeight, 2)));
      return diagonal + this.props.radius;
    }
  }, {
    key: 'getX',
    value: function getX() {
      var pos = this.props.usePercentage ? this.state.windowWidth * this.props.x / 100 : this.props.x;
      return pos + 'px';
    }
  }, {
    key: 'getY',
    value: function getY() {
      var pos = this.props.usePercentage ? this.state.windowHeight * this.props.y / 100 : this.props.y;
      return pos + 'px';
    }
  }, {
    key: 'getInnerStyles',
    value: function getInnerStyles() {
      var _props = this.props,
          animSpeed = _props.animSpeed,
          radius = _props.radius,
          borderWidth = _props.borderWidth,
          color = _props.color,
          innerStyles = _props.innerStyles;

      var diameter = radius * 2 + borderWidth * 2;

      return _extends({
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: diameter,
        height: diameter,
        transform: 'translate(-50%, -50%)',
        border: this.getBorderSize() + 'px solid ' + color,
        opacity: 0.9,
        borderRadius: '50%',
        boxSizing: 'content-box',
        transitionDuration: animSpeed + 'ms',
        transitionProperty: 'all'
      }, innerStyles);
    }
  }, {
    key: 'getOuterStyles',
    value: function getOuterStyles() {
      var _props2 = this.props,
          animSpeed = _props2.animSpeed,
          borderWidth = _props2.borderWidth,
          borderColor = _props2.borderColor,
          radius = _props2.radius,
          outerStyles = _props2.outerStyles;

      var diameter = radius * 2;

      return _extends({
        position: 'fixed',
        left: -radius - borderWidth,
        top: -radius - borderWidth,
        width: diameter,
        height: diameter,
        borderRadius: '50%',
        zIndex: 999,
        boxSizing: 'content-box',
        border: borderWidth + 'px solid ' + borderColor,
        transform: 'translate(' + this.getX() + ', ' + this.getY() + ')',
        transitionDuration: animSpeed + 'ms',
        transitionProperty: 'all'
      }, outerStyles);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          style: this.getOuterStyles(),
          className: this.props.outerClass || ''
        },
        _react2.default.createElement(
          'div',
          {
            style: this.getInnerStyles(),
            className: this.props.innerClass || ''
          },
          this.props.children
        )
      );
    }
  }]);

  return Spotlight;
}(_react2.default.Component);

exports.default = Spotlight;


Spotlight.propTypes = {
  color: _propTypes2.default.string,
  x: _propTypes2.default.number,
  y: _propTypes2.default.number,
  radius: _propTypes2.default.number,
  responsive: _propTypes2.default.bool,
  outerClass: _propTypes2.default.string,
  innerClass: _propTypes2.default.string,
  outerStyles: _propTypes2.default.object,
  innerStyles: _propTypes2.default.object,
  borderWidth: _propTypes2.default.number,
  borderColor: _propTypes2.default.string,
  animSpeed: _propTypes2.default.number,
  usePercentage: _propTypes2.default.bool
};

Spotlight.defaultProps = {
  color: 'black',
  x: 50,
  y: 50,
  radius: 100,
  responsive: true,
  usePercentage: false,
  borderWidth: 0,
  borderColor: 'white',
  animSpeed: 500,
  outerStyles: {},
  innerStyles: {}
};